<template>
  <CustomUpdateDialog
    dialogTitle="ویرایش وضعیت سفارش"
    dialogId="update-order-status-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="changeThisOrderStatus"
  >
    <BCol cols="12">
      <OrderStatusPicker
        :doesHaveAllOption="false"
        v-model="changeOrderStatusPayload.status"
      ></OrderStatusPicker>
    </BCol>
  </CustomUpdateDialog>
</template>
<script>
export default {
  emits: ["refetch"],
  props: {
    currentOrderStatus: {
      type: [Number, String],
    },
    orderId: {
      type: [String, Number],
      required: false,
    },
  },
  watch: {
    currentOrderStatus: {
      handler(val) {
        if (val) {
          this.changeOrderStatusPayload.status = val;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      changeOrderStatusPayload: {
        orderId: null,
        status: null,
      },
      isOkButtonDisabled: false,
    };
  },
  methods: {
    async changeThisOrderStatus() {
      try {
        this.isOkButtonDisabled = true;
        this.changeOrderStatusPayload.orderId = this.orderId;
        let _this = this;
        let changeOrderStatus = new ChangeOrderStatus(_this);
        changeOrderStatus.setRequestParam(_this.changeOrderStatusPayload);
        await changeOrderStatus.fetch((response) => {
          if (response.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش شد.",
                icon: "EditIcon",
                variant: "success",
                text: "وضعیت سفارش با موفقیت تغییر کرد",
              },
            });
            _this.$emit("refetch");
            _this.$bvModal.hide("update-order-status-dialog");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "ویرایش نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isOkButtonDisabled = false;
      }
    },
  },
  components: {
    CustomUpdateDialog,
    OrderStatusPicker,
    BCol,
  },
};
import CustomUpdateDialog from "@/views/components/Utils/Dialogs/CustomUpdateDialog.vue";
import OrderStatusPicker from "@/views/components/Orders/OrderStatusPicker.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { ChangeOrderStatus } from "@/libs/Api/Order";
</script>
